function normalizeHostname(hostOrUrl) {
  if (typeof hostOrUrl !== "string") return null;

  const normalizedValue = hostOrUrl.trim();
  if (!normalizedValue) return null;

  try {
    return new URL(normalizedValue.includes("://") ? normalizedValue : `https://${normalizedValue}`).hostname;
  } catch {
    return null;
  }
}

export function isShortlinkUrl(url, shortlinkDomain) {
  const urlHostname = normalizeHostname(url);
  const shortlinkHostname = normalizeHostname(shortlinkDomain);

  return !!urlHostname && !!shortlinkHostname && urlHostname === shortlinkHostname;
}

export function unwrapCorsProxyUrl(url, corsProxyServer) {
  if (typeof url !== "string" || !url) return null;
  if (!corsProxyServer) return url;

  const proxyPrefix = `https://${corsProxyServer}/`;
  if (!url.startsWith(proxyPrefix)) {
    return url;
  }

  return decodeURIComponent(url.substring(proxyPrefix.length));
}

export async function resolveShortlinkTarget(url, { shortlinkDomain, corsProxyServer, fetchImpl = fetch } = {}) {
  if (!isShortlinkUrl(url, shortlinkDomain) || typeof fetchImpl !== "function") {
    return null;
  }

  const requestUrl = corsProxyServer ? `https://${corsProxyServer}/${url}` : url;
  const response = await fetchImpl(requestUrl, { method: "GET", redirect: "follow" });
  const finalUrl = unwrapCorsProxyUrl(response?.url, corsProxyServer);

  if (!finalUrl || finalUrl === url) {
    return null;
  }

  return finalUrl;
}
